import { memo, MouseEvent as ReactMouseEvent, useCallback } from "react";
import classnames from "classnames";
import { ClearIndicatorProps } from "react-select";
import ClearButton from "../Input/ClearButton";

import styles from "./style.module.scss";

export const ClearIndicator = memo<ClearIndicatorProps<any>>((props) => {
  const { children, className, getStyles, innerProps } = props;
  const onMouseDown = useCallback((e: ReactMouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  return (
    <div
      aria-hidden={"true"}
      style={getStyles("clearIndicator", props) as any}
      className={classnames(
        {
          indicator: true,
          "clear-indicator": true,
        },
        className,
        styles.clearBtn,
      )}
    >
      {children || <ClearButton
        onMouseDown={onMouseDown}
        onClick={innerProps.onMouseDown as any} />}
    </div>
  );
});
